import { put, call, select, takeLatest } from "redux-saga/effects";
import * as services from "./service";
import CONSTANTS from "./constants";

function* getUserDetails(payload) {
  const response = yield call(services.getUserDetailsService, {
    ...payload,
  });
  switch (response && response.status) {
    case 200: {
      yield put({
        type: CONSTANTS.GET_USER_DETAILS_SUCCESS,
        payload: response?.data,
      });
      break;
    }
    case 400: {
      yield put({
        type: CONSTANTS.SET_IS_LOADING,
        payload: false,
      });
    }
    default:
      return;
  }
}

export default function* actionWatcher() {
  yield takeLatest(CONSTANTS.GET_USER_DETAILS, getUserDetails);
}
